import React from 'react'

class Spacer extends React.Component {
  render() {
    return <div style={{ flexGrow: '1' }} />
  }
}

export default Spacer
